angular.module('tgaAdmin')
  .controller('DomainsController', [
    '$scope', '$state', 'reportService',
    function (
      $scope, $state, reportService,
    ) {
      $scope.data = {
        alerts: [],
      };

      $scope.viewmodel = {
        domains: [],
      };

      $scope.actions = {
        loadDomains(tableState) {
          $scope.loading = true;

          const params = tableState
            ? {
              paginate: true,
              page: Math.floor(tableState.pagination.start / tableState.pagination.number) + 1,
              limit: tableState.pagination.number,
              sort: tableState.sort.predicate,
              order: tableState.sort.reverse ? 'desc' : 'asc',
            }
            : {};

          if (tableState?.search?.predicateObject) {
            Object.keys(tableState.search.predicateObject).forEach((key) => {
              params[key] = tableState.search.predicateObject[key];
            });
          }

          reportService.getDomainReport(params).then((response) => {
            // Check for paginated response coming from `items` before falling back to the response
            $scope.viewmodel.domains = response.items || response;
            $scope.loading = false;

            if (tableState) {
              tableState.pagination.numberOfPages = Math.ceil(response.total / tableState.pagination.number);
              tableState.pagination.totalItemCount = response.total;
            }
          });
        },

        createAlert(msg, type) {
          $scope.data.alerts = [];
          $scope.data.alerts.push({
            msg,
            type,
          });
        },
      };
    },
  ]);
